// extracted by mini-css-extract-plugin
module.exports = {"token":"_6h97P","field":"pkgSX","operator":"BIrA4","values":"H9hCt","truncated":"dn94Z"};